export default {
    state: {
        findJobs: false,
    },
    getters: {
        shouldFakeLoadFindJobs: state => payload => state.findJobs,
    },
    mutations: {
        startFindJobsFakeLoad(state) {
            console.log('Starting fake load');
            state.findJobs = true;
            setTimeout(() => {
                console.log('Stopping fake load');
                state.findJobs = false;
            }, 1000);
        },
    },
};
